import FingerprintJS from '@fingerprintjs/fingerprintjs';

// Function to get or create a fingerprint
export const getFingerprint = async () => {
  try {
    // Check if a fingerprint already exists in localStorage
    const storedFingerprint = localStorage.getItem('fingerprint');
    if (storedFingerprint) {
      // alert('heremhm');

      console.log(
        'Fingerprint retrieved from localStorage:',
        storedFingerprint
      );
      return storedFingerprint;
    }

    // If no fingerprint exists, generate a new one
    const fpPromise = FingerprintJS.load();
    const fp = await fpPromise;
    const result = await fp.get();
    const visitorId = result.visitorId;

    // alert('here');
    // Store the fingerprint in localStorage
    localStorage.setItem('fingerprint', visitorId);

    console.log('New fingerprint generated and stored:', visitorId);
    return visitorId;
  } catch (error) {
    console.error('Error generating or retrieving fingerprint:', error.message);
    throw new Error('Failed to generate or retrieve fingerprint.');
  }
};